export default "__VITE_ASSET__CgsT9i2n__"